import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';

import { ViewBasePage } from '@shared/pages';
import type { TReportType } from '@shared/models';

@Component({
    'selector': 'app-reportsBase',
    'templateUrl': './reportsBase.page.html',
    'styleUrls': ['./reportsBase.page.scss'],
})
export class ReportsBasePage extends ViewBasePage implements OnInit, OnDestroy {
    protected vm: any = {};
    // public summaryReports: TReportType[] = [
    //     {
    //         // Add columns:  NumberOfTicketsCreated, NumberOfTicketsCompleted.  Look at ticketDetail
    //         'title': 'Tickets Summary Report',
    //         'description': 'Number of tickets created by service advisor per day.',
    //         'name': 'ticketSummary',
    //         'columns': ['Ticket Creation Date', 'Number of Tickets', 'Service Advisor'],
    //         'colWidths': [100, 50, 200],
    //         'reportParmsNeeded': true
    //     },
    //     {
    //         'title': 'Trips Summary Report',
    //         'description': 'Number of trips per day.',
    //         'name': 'tripSummary',
    //         'columns': ['Trip Completed Date', 'Number of Trips', 'Driver'],
    //         // 'sortColumns': [0],
    //         'colWidths': [50, 50, 50, 50],
    //         'reportParmsNeeded': true
    //     },
    //     {
    //         'title': 'Campaign Summary Report',
    //         'description': 'Number of incentives sent per campaign.',
    //         'name': 'campaignSummary',
    //         'columns': ['Campaign Date', 'Num Recipients'],
    //         'colWidths': [50, 50],
    //         'reportParmsNeeded': true
    //     },
    //     {
    //         'title': 'Customer Summary Report',
    //         'description': 'Number of customers acquired per day.',
    //         'name': 'customerSummary',
    //         'columns': ['Date', 'Number of Customers Acquired'],
    //         'sortColumns': [0],
    //         'colWidths': [40, 130],
    //         'reportParmsNeeded': true
    //     },
    //     {
    //         'title': 'Dashboard Summary Report',
    //         'description': 'Overall statistics of the dealership.',
    //         'name': 'dashboardSummary',
    //         'columns': ['Category ', 'Count'],
    //         'colWidths': [20, 20],
    //         'reportParmsNeeded': false
    //     },
    // ];

    // public detailReports = [
    //     {
    //         'title': 'Ticket Detail Report',
    //         'description': 'Ticket details processed per day.',
    //         'name': 'ticketDetail',
    //         'columns': ['Created Date', 'Completed Date', 'Duration', 'Location', 'Service Advisor', 'Driver'],
    //         'colWidths': [30, 30, 30, 30, 30, 20],
    //         'reportParmsNeeded': true
    //     },
    //     {
    //         'title': 'Passenger Timing Detail Report',
    //         'description': 'Passenger wait times.',
    //         'name': 'passengerDetail',
    //         'columns': ['Created Date', 'Assigned', 'Enroute', 'Current', 'Completed', 'Passenger', 'Destination', 'Driver'],
    //         'colWidths': [30, 30, 30, 30, 30, 30, 30, 30],
    //         'reportParmsNeeded': true
    //     },
    //     {
    //         'title': 'SMS Detail Report',
    //         'description': 'SMS message specifics.',
    //         'name': 'smsDetail',
    //         'columns': ['Sent Date', 'Sent Time', 'Customer Name', 'Cell Phone', 'Type', 'Text Message'],
    //         'colWidths': [10, 15, 30, 20, 20, 40],
    //         'reportParmsNeeded': true
    //     },
    // ];

    // public setupReports = [
    //     {
    //         'title': 'Account Profile Report',
    //         'description': 'View the current details of your account.',
    //         'name': 'accountProfile',
    //         'columns': [' ', ' '],
    //         'colWidths': [40, 160],
    //         'reportParmsNeeded': false
    //     },
    //     {
    //         'title': 'Users Report',
    //         'description': 'View who has access to your account.',
    //         'name': 'users',
    //         'columns': ['Name', 'Cell Phone', 'Email', 'Role'],
    //         'colWidths': [70, 50, 90, 190],
    //         'reportParmsNeeded': false
    //     },
    //     {
    //         'title': 'Shuttles Report',
    //         'description': 'View which shuttles are configured.',
    //         'name': 'shuttles',
    //         'columns': ['Shuttle Name', 'Status', 'Capacity', 'Color', 'Description'],
    //         'colWidths': [70, 70, 70, 70, 340],
    //         'reportParmsNeeded': false
    //     },
    //     {
    //         'title': 'Service Areas Report',
    //         'description': 'View which areas your shuttles service.',
    //         'name': 'serviceAreas',
    //         'columns': ['Zipcode', 'Distance', 'City'],
    //         'colWidths': [30, 40, 300],
    //         'reportParmsNeeded': false
    //     }
    // ];

    constructor(injector: Injector) {
        super(injector);
        this.vm = {};
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        this.vm.isDebugMode = this.sessionService.isDebugMode();
        // this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-reports-tour');
    // }

    // public onNextClick() {
    //     if (this.vm.selectedReport) {
    //         super.setViewModel(this.vm);
    //         if (this.vm.selectedReport.reportParmsNeeded) {
    //             this.router.navigateByUrl('/reportsPage2');
    //         } else {
    //             this.router.navigateByUrl('/reportsPage3');
    //         }
    //     }
    // }

    // public onChooseReportClick(report) {
    //     this.vm.selectedReport = report;
    // }
}
